import { render, staticRenderFns } from "./KitchenDisplay.vue?vue&type=template&id=145b7c00&scoped=true"
import script from "./KitchenDisplay.vue?vue&type=script&lang=js"
export * from "./KitchenDisplay.vue?vue&type=script&lang=js"
import style0 from "./KitchenDisplay.vue?vue&type=style&index=0&id=145b7c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b7c00",
  null
  
)

export default component.exports